import React from "react";
import { ContentContainer } from "components/shared";
import WindTurbinesGrid from "./WindTurbinesGrid";
import WindTurbinesMap from "./WindTurbinesMap";
import WindTurbinesList from "./WindTurbinesList";
import { TURBINE_VIEW_MODES } from "../../constants";

// View-mode switching (Dashboard/Map/List) now lives in the sidebar nav,
// not as buttons here - this component just renders whichever view is
// currently selected in state.dashboard.viewMode.
const Main = ({ viewMode, ...props }) => {
  let content;

  switch (viewMode) {
    case TURBINE_VIEW_MODES.GRID:
      content = <WindTurbinesGrid {...props} />;
      break;
    case TURBINE_VIEW_MODES.MAP:
      content = <WindTurbinesMap {...props} />;
      break;
    case TURBINE_VIEW_MODES.LIST:
      content = <WindTurbinesList {...props} />;
      break;

    default:
      break;
  }

  return <ContentContainer>{content}</ContentContainer>;
};

export default Main;
